export default "__VITE_ASSET__DpXENvVk__"